
const message = {
    verifyMessage:"The account is wrong or there are multiple, please contact customer service for processing.",
    noGoodsMessage:"No product type selected",
    noPayTypeMessage:'No payment method selected',
    noAcceptMessage:"Not agreeing to terms",
    noAccountMessage:"The account number was not entered",
    buyLinkFailMessage:"Failed to obtain payment link, please contact customer service.",
}


const buyInfo = {
    topTitleLeft:"Pocket Forex",
    topTitleRight:"PayCenter",
    buyTitle:"Pcoins",
    account:"Pocket Account",
    payMethod:"Payment Method",
    payButtonContent:"To pay",
    acceptTerms:"I confirm that I have read the \"Terms of Service\" and\"Privacy Policy\" and accept all ",
    inputDefaultContent:"Please enter your pocket account",
    vipBuyTitle:"VIP Membership",
    month:"Months",
    save:"Save",
    noSave:"No Discount",
    mo:"mo",
}

const resultInfo = {
    content:"Checking payment result...",
    successText:"Purchase successful",
    buttonText:"Return to homepage",
    failText:"Purchase failed"
}

const orderInfo = {
    payment:"Payment",
}

const title={
    pbTitle:"Pcoin Deposit",
    vipTitle:"Purchase Vip",
}

export default {buyInfo,resultInfo,orderInfo,message,title}